import React, { Component, Fragment } from "react";
import aggregacao from "../aggregacao";
import { parseLabelCampo } from "../../../../constants/metricas";
import chartConfig from "../chartConfig";
import LinhaModalidade from "./LinhaModalidade";

export default class ResumoModalidades extends Component {

    render() {
        let { linhas, mes } = this.props;
        let linhasCube = linhas || [];
        let linhasResumo = aggregacao.resumoPorModalidade(linhasCube, mes);

        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <h5>Resumo por modalidade</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered table-hover table-sm">
                                <thead>
                                    <tr>
                                        <th>Modalidade</th>
                                        {aggregacao.COLUNAS_RESUMO_MODALIDADE.map((campo) => (
                                            <th key={campo}>{parseLabelCampo(campo)}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {linhasResumo.map((linha) => (
                                        linha.modalidade === "TOTAL" ? (
                                            <tr key="TOTAL" className="table-secondary">
                                                <td>{linha.modalidade}</td>
                                                {aggregacao.COLUNAS_RESUMO_MODALIDADE.map((campo) => (
                                                    <td key={campo}>{chartConfig.formatarNumeroPtBr(linha[campo])}</td>
                                                ))}
                                            </tr>
                                        ) : (
                                            <LinhaModalidade
                                                key={linha.modalidade}
                                                linha={linha}
                                                linhasCube={linhasCube.filter((l) => l.modalidade === linha.modalidade)}
                                                mes={mes}
                                            />
                                        )
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
